// src/components/UltimaHora.jsx
import React from "react";
import Slider from "react-slick";
import data from "../data/data.json";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// 1. Modificamos los settings para una altura consistente
const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  arrows: true,
  // Ordena los breakpoints de mayor a menor
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 480, // Valor de breakpoint más bajo para móviles
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
  // El resto de tus configuraciones
  appendDots: (dots) => (
    <div
      style={{
        position: "relative",
        bottom: "-40px",
      }}
    >
      <ul style={{ margin: "0px" }}> {dots} </ul>
    </div>
  ),
};

export default function UltimaHora() {
  const fotos = data.latestPhotos || [];

  return (
    <section id="gallery-hora" className="gallery-wrapper">
      <div className="slider-container">
        <h2>Última hora</h2>
        <Slider {...settings}>
          {fotos.map((f, i) => (
            <div key={i} style={{ padding: "0 10px" }}>
              <div
                style={{
                  height: "500px", // Define una altura máxima para las imágenes
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#f9f9f9", // Color de fondo opcional
                  borderRadius: "10px",
                }}
              >
                <img
                  src={f.src}
                  alt={f.alt}
                  style={{
                    maxWidth: "100%",    // La imagen no superará el ancho del contenedor
                    maxHeight: "100%",   // La imagen no superará la altura del contenedor
                    width: "auto",       // El ancho se ajusta automáticamente
                    height: "auto",      // La altura se ajusta automáticamente
                    objectFit: "contain",// Asegura que toda la imagen sea visible
                  }}
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
